/* eslint-disable */
import React, { useState, useRef} from 'react';

import { useForm, Controller } from "react-hook-form"


import DatePicker from "react-datepicker";


export default function  WaitTillBox({event, setEdges}){
    const newRef = useRef();
    const [dateType, setDateType] = useState(event.data.schedule.dateType);
    let dt = ""
    if (event.data.schedule.date && event.data.schedule.date != "") {
        const newDt = event.data.schedule.date.split("-")
        dt = new Date(newDt[0], newDt[1], newDt[2], event.data.schedule.hours)
    } else {
        dt = new Date()
    }
    const { register: wait_reg, control: wait_control, handleSubmit: wait_handle } = useForm({
        defaultValues: {
            "schType": "wait_till",
            "dateType": event.data.schedule.dateType,
            "days": event.data.schedule.days,
            "hours": event.data.schedule.hours,
            "mins": event.data.schedule.mins,
            "date": dt
        }
    });


    const wait_set = (val, typo) => {
        setEdges(nds => {
            return nds.map(i => {
                if (i.id == event.id) {
                    i.data.schedule.schType = "wait_till"
                    if (typo == "mins") {
                        i.data.schedule.mins = val
                    } else if (typo == "hours") {
                        i.data.schedule.hours = val
                    } else if (typo == "days") {
                        i.data.schedule.days = val
                    } else if (typo == "date") {
                        const dateObj = new Date(val);
                        const year = dateObj.getFullYear();
                        const month = String(dateObj.getMonth()).padStart(2, '0');
                        const day = String(dateObj.getDate()).padStart(2, '0');
                        const formattedDate = `${year}-${month}-${day}`;
                        i.data.schedule.date = formattedDate
                        i.data.schedule.hours = String(dateObj.getHours()).padStart(2, '0')
                    } else if (typo == "dateType") {
                        i.data.schedule.dateType = val
                        setDateType(val)
                    }
                }
                return i
            })
        })
    }

    const NewBox = () => {
        if (dateType != "") {
            if (dateType == "normal") {
                return (
                    <div className="flex justify-around  bg-white_green">
                        <div className="flex flex-col">
                            <select {...wait_reg("days", { required: true, onChange: (e) => wait_set(e.target.value, "days") })} className='form-select'>
                                {Array.from(Array(31).keys()).map(item => <option value={item}>{item}</option>)}
                            </select>
                            <span className="text-sm font-semibold text-slate-500">After Days </span>
                        </div>
                        <div className="flex flex-col">
                            <select {...wait_reg("hours", { required: true, onChange: (e) => wait_set(e.target.value, "hours") })} className='form-select'>
                                {Array.from(Array(24).keys()).map(item => <option value={item}>{item}</option>)}
                            </select>
                            <span className="text-sm font-semibold text-slate-500">After HOURS </span>
                        </div>
                    </div>
                )
            }
            else if (dateType == "date") {
                return (
                    <div>
                        <Controller
                            name={'date'}
                            control={wait_control}
                            value={dt}
                            render={({ field }) => {
                                return (<DatePicker
                                    className="form-control"
                                    selected={field.value}
                                    dateFormat="MMMM d, yyyy HH:mm"
                                    showTimeSelect
                                    timeFormat="HH"
                                    timeIntervals={60}
                                    minDate={new Date()}
                                    onChange={(date) => {
                                        field.onChange(date)
                                        wait_set(date, "date");
                                    }}
                                />
                                )
                            }}
                            rules={{ required: true }}
                        />
                    </div>
                )
            }

            else if (dateType == "today") {
                return (
                    <div className="flex justify-around  bg-white_green">
                        <div className="flex flex-col">
                            <select {...wait_reg("hours", { required: true, onChange: (e) => wait_set(e.target.value, "hours") })} className='form-select'>
                                {Array.from(Array(24).keys()).map(item => <option value={item}>{item}</option>)}
                            </select>
                            <span className="text-sm font-semibold text-slate-500">HOURS </span>
                        </div>
                        <div className="flex flex-col">
                            <select {...wait_reg("mins", { required: true, onChange: (e) => wait_set(e.target.value, "mins") })} className='form-select'>
                                <option value='0'>0</option>
                                <option value='15'>15</option>
                                <option value='30'>30</option>
                                <option value='45'>45</option>
                            </select>
                            <span className="text-sm font-semibold text-slate-500">Mins </span>
                        </div>
                    </div>
                )
            }
        }
    }

    return (
        <div className="card-body mt-0 ">
            <div className="contact_add_div">
                <div className="mx-auto" ref={newRef}>
                    <input {...wait_reg("schType", { required: true })} type="hidden" value='wait_till' />
                    <select {...wait_reg("dateType", { required: true, onChange: (e) => wait_set(e.target.value, 'dateType') })} className='form-select color_date_bg'>
                        <option value="">Select Date Type</option>
                        <option value="normal">Normal</option>
                        <option value="today">Today</option>
                        <option value="date">Date</option>
                    </select>
                    <NewBox />
                </div>
            </div>
        </div>
    )
}